export default function AboutSection() {
  return (
    <section id="o-nas" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-800 text-xs font-medium rounded-full mb-5">
            O USFansSpreadsheet
          </span>

          <div className="max-w-3xl">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-4">
              <strong>USFansSpreadsheet</strong> to zaawansowany arkusz kalkulacyjny stworzony z myślą o polskich fanach amerykańskich produktów. Narzędzie to umożliwia szybkie porównywanie cen, dostępności i parametrów produktów z różnych kategorii – od <strong>Shoes</strong> i <strong>Hoodies/Sweaters</strong>, przez <strong>T-Shirts</strong> i <strong>Jackets</strong>, aż po <strong>Accessories</strong> i <strong>Perfumes</strong>.
            </p>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-4">
              Dzięki regularnym cotygodniowym aktualizacjom, <strong>USFansSpreadsheet</strong> zawsze zawiera najbardziej aktualne dane. Niezależnie od tego, czy szukasz najlepszych okazji w kategorii <strong>Jersey</strong>, czy porównujesz ceny <strong>Bags</strong>, nasz przewodnik pomoże Ci podjąć świadomą decyzję zakupową.
            </p>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
              <strong>USFansSpreadsheet</strong> wyróżnia się na tle konkurencji kompleksowym podejściem – obejmuje wszystkie 14 kategorii produktowych, oferuje przejrzysty interfejs i jest całkowicie bezpieczny w użyciu. To idealne narzędzie dla każdego, kto ceni sobie czas i chce mieć wszystkie informacje w jednym miejscu.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {[
            { value: "500+", label: "Produktów w bazie" },
            { value: "14", label: "Kategorii" },
            { value: "99%", label: "Dokładność danych" },
            { value: "24/06/2026", label: "Ostatnia aktualizacja" },
          ].map((stat, i) => (
            <div key={i} className="text-center p-5 md:p-6 bg-background-100 border border-background-200/70 rounded-xl">
              <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1">{stat.value}</div>
              <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}